module.exports = __webpack_public_path__ + "fi.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/fi.svg
// module id = 542
// module chunks = 0